import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class ErrorService {

    getClientMessage(error: Error | unknown): string {
        if (!navigator.onLine) {
            return 'No Internet Connection';
        }
        if (error == null) {
            return 'Unknown error';
        }
        if (error instanceof Error) {
            return error.message ? error.message : error.toString();
        }
        if (typeof error === 'string') {
            return error;
        }
        return String(error);
    }

    getClientStack(error: Error | unknown): string {
        if (error instanceof Error) {
            return error.stack ? error.stack : '';
        }
        return '';
    }

    getServerMessage(error: HttpErrorResponse): string {
        return error.message;
    }

    getServerStack(error: HttpErrorResponse): string {
        // handle stack trace
        return 'stack';
    }
}